<template>
    <div class="">
        <div>
            <h1 class="text-center mt-5">Odeslání mailů</h1>
            <hr class="w-75 mx-auto">
        </div>
        <div class="row w-75 mx-auto mt-4">
            <div v-if="successMessage" class="alert alert-success" role="alert">
                Email byl úspěšně odeslán.
            </div>
            <div v-if="errorMessage" class="alert alert-danger" role="alert">
                Došlo k chybě při odesílání emailu.
            </div>
            <div v-if="missingPersonalSettings" class="alert alert-warning" role="alert">
                Nejprve si nastavte osobní nastavení v sekci <router-link to="/settings">Nastavení</router-link>.
            </div>
            <!-- Subject -->
            <div>
                <label class="form-label mt-3"><span class="text-danger">*</span>Předmět</label>
                <input type="text" class="form-control" placeholder="Zde vložte předmět" v-model="postData.subject" />
            </div>
            <div>
                <div class="mt-3">
                    <!-- Addresses -->
                    <label class="form-label"><span class="text-danger">*</span>Adresy</label>
                    <button class="btn btn_primary ms-3" data-bs-toggle="modal" data-bs-target="#inportGroup">
                        Nahrát skupinu adres
                    </button>
                    <Popup :header="'Nahrát skupinu adres'" :editable="false" :button="'Nahrát'" id="inportGroup"
                        @save-data="importGroup()">
                        <template v-slot:body>
                            <div>
                                <h4>Vyberte skupinu adres:</h4>
                            </div>
                            <div>
                                <select class="form-select" v-model="selectedEmailGroup">
                                    <option v-for="(group, i) in emailGroups" :key="i" :value="group">
                                        {{ group.name }}
                                    </option>
                                </select>
                            </div>
                        </template>
                    </Popup>
                </div>
                <textarea class="form-control mt-2" rows="6" placeholder="Zde vložte adresy mailů"
                    v-model="postData.emails"></textarea>
            </div>
            <!-- Email body -->
            <div>
                <label class="form-label mt-3"><span class="text-danger">*</span>Text emailu</label>
                <textarea class="form-control" rows="6" placeholder="Zde vložte text emailu"
                    v-model="postData.body"></textarea>
            </div>
            <!-- Attachments -->
            <div class="mt-3">
                <label for="formFile" class="form-label">Vyberte přilohy</label>
                <input class="form-control" type="file" id="formFile" multiple @change="onFileChange" />
            </div>
            <div class="mt-3">
                <button class="btn btn_primary px-5" @click="sendEmail()">Odeslat</button>
                <div v-if="loading" class="spinner-border text-primary ms-3" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Popup from '../components/Popup.vue'
export default {
    components: {
        Popup
    },
    data() {
        return {
            emailGroups: [],
            selectedEmailGroup: null,
            postData: {
                subject: '',
                body: '',
                emails: '',
                attachments: [],
            },
            successMessage: false,
            errorMessage: false,
            missingPersonalSettings: false,
            loading: false,
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.$store.getters.api.get('/settings').then(response => {
                if (response.data.settings.email_address !== null && response.data.settings.email_host !== null) {
                    this.missingPersonalSettings = false;
                } else {
                    this.missingPersonalSettings = true;
                }
            })
            this.$store.getters.api.get('/settings/groups').then(response => {
                this.emailGroups = response.data.groups;
            })
        },
        onFileChange(event) {
            this.postData.attachments = Array.from(event.target.files);
        },
        async sendEmail() {
            this.successMessage = false;
            this.errorMessage = false;
            this.loading = true;
            const attachments = [];

            for (let file of this.postData.attachments) {
                const base64 = await this.fileToBase64(file);
                attachments.push({
                    filename: file.name,
                    content: base64.split(',')[1], // Get the base64 content without the prefix
                    mime_type: file.type || 'application/octet-stream' // Default to octet-stream if type is not available
                })
            }

            const dataToSend = {
                subject: this.postData.subject,
                body: this.postData.body,
                emails: this.postData.emails,
                attachments: attachments,
            };

            this.$store.getters.api.post('/email/send', dataToSend).then(response => {
                if (response.status === 200) {
                    this.loading = false;
                    this.successMessage = true;
                    this.errorMessage = false;
                    this.postData = {
                        subject: '',
                        body: '',
                        emails: '',
                        attachments: [],
                    };
                }
            }).catch(error => {
                this.loading = false;
                this.errorMessage = true;
            });
        },
        fileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        importGroup() {
            this.postData.emails = this.selectedEmailGroup.emails.map(email => email.email).join('\n');
        }
    },
}
</script>
<style lang="">

</style>